<template>
    <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
        <side-bar
                :background-color="sidebarBackground"
                short-title="Онлайн-курс"
                title="Онлайн-курс"
        >
            <template slot="links">

                <sidebar-item
                        :link="{name: '1.1 Holiday Plans', icon: 'ni ni-lock-circle-open text-green', path: '/lesson/1'}"/>

                <sidebar-item
                        :link="{name: '1.2 Holiday Plans', icon: 'ni ni-lock-circle-open text-green', path: '/lesson/2'}"/>

                <sidebar-item
                        :link="{name: '1.3 Holiday Plans', icon: 'ni ni-lock-circle-open text-green', path: '/lesson/3'}"/>

                <sidebar-item
                        :link="{name: '2.1 Holiday Plans', icon: 'ni ni-lock-circle-open text-green', path: '/lesson/4'}"/>

                <sidebar-item
                        :link="{name: '2.2 Holiday Plans', icon: 'ni ni-lock-circle-open text-green', path: '/lesson/5'}"/>

                <sidebar-item
                        :link="{name: 'N.N Holiday Plans', icon: 'ni ni-watch-time text-gray', path: ''}"/>
                <!--
                <sidebar-item
                  :link="{
                    name: 'Dashboard',
                    icon: 'ni ni-tv-2 text-primary',
                    path: '/dashboard'
                  }"
                />

                <sidebar-item :link="{name: 'Icons', icon: 'ni ni-planet text-blue', path: '/icons'}"/>
                <sidebar-item :link="{name: 'Maps', icon: 'ni ni-pin-3 text-orange', path: '/maps'}"/>
                <sidebar-item :link="{name: 'User Profile', icon: 'ni ni-single-02 text-yellow', path: '/profile'}"/>
                <sidebar-item :link="{name: 'Tables', icon: 'ni ni-bullet-list-67 text-red', path: '/tables'}"/>
                <sidebar-item :link="{name: 'Login', icon: 'ni ni-key-25 text-info', path: '/login'}"/>
                <sidebar-item :link="{name: 'Register', icon: 'ni ni-circle-08 text-pink', path: '/register'}"/>
                -->

            </template>
        </side-bar>
        <div class="main-content" :data="sidebarBackground">
            <dashboard-navbar></dashboard-navbar>

            <div @click="toggleSidebar">
                <fade-transition :duration="200" origin="center top" mode="out-in">
                    <!-- your content here -->
                    <router-view></router-view>
                </fade-transition>
                <content-footer v-if="!$route.meta.hideFooter"></content-footer>
            </div>
        </div>
    </div>
</template>
<script>
    import DashboardNavbar from './DashboardNavbar.vue';
    import ContentFooter from './ContentFooter.vue';
    import {FadeTransition} from 'vue2-transitions';

    export default {
        components: {
            DashboardNavbar,
            ContentFooter,
            FadeTransition
        },
        data() {
            return {
                sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
            };
        },
        methods: {
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            }
        }
    };
</script>
<style lang="scss">
</style>
